<template>
    <div class="container" style="padding-left: 20px;">
        <div style="width: 450px;">
            <div v-if="result">
                <div v-if="created" class="alert alert-success" role="alert">New user created.</div>
                <h6>User Credentials</h6>
                <ul class="list list-unstyled">
                    <li>Email: {{ result.email }}</li>
                    <li>Password: {{ result.password }}</li>
                    <li v-if="result.regDate">Registered: {{ formatRegDate(result.regDate) }}</li>
                </ul>
                <div class="mb-3">
                    <button type="button" class="btn btn-primary" @click="clearForm">New Request</button>
                </div>
            </div>

            <div v-else-if="notFound">
                <div class="alert alert-warning" role="alert">
                    No portal user with this email.
                </div>
                <p>Create a new user for <strong>{{ email }}</strong>?</p>
                <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
                <div class="mb-3">
                    <button type="button" class="btn btn-primary me-2" :disabled="submitting" @click="backToSearch">
                        Back
                    </button>
                    <button type="button" class="btn btn-outline-secondary" :disabled="submitting" @click="createUser">
                        {{ submitting ? 'Working…' : 'Create User' }}
                    </button>
                </div>
            </div>

            <form class="form" @submit.prevent="findUser" v-else>
                <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>

                <div class="mb-3">
                    <label class="form-label">User Email</label>
                    <input type="email" class="form-control" v-model="email" placeholder="User Email" required />
                    <div class="form-text">
                        Looks up an existing portal user. If none is found, you can create one.
                    </div>
                </div>

                <div class="mb-3">
                    <button type="submit" class="btn btn-primary" :disabled="submitting">
                        {{ submitting ? 'Working…' : 'Find User' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import myAxios from "@/services/myAxios";

function formatRegDate(value) {
    if (!value) {
        return "";
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
        return String(value).slice(0, 10);
    }
    return d.toISOString().slice(0, 10);
}

export default {
    name: "RegisterUser",
    data() {
        return {
            email: "",
            result: null,
            created: false,
            notFound: false,
            error: null,
            submitting: false,
        };
    },
    methods: {
        formatRegDate,
        clearForm() {
            this.email = "";
            this.result = null;
            this.created = false;
            this.notFound = false;
            this.error = null;
        },
        backToSearch() {
            this.notFound = false;
            this.error = null;
        },
        apiError(ex, fallback) {
            const msg =
                (ex.response && ex.response.data) ||
                ex.message ||
                fallback;
            return typeof msg === "string" ? msg : JSON.stringify(msg);
        },
        applyUser(data, created) {
            this.notFound = false;
            this.created = !!created;
            this.result = {
                email: data.email,
                password: data.password,
                regDate: data.regDate || null,
            };
        },
        findUser() {
            this.error = null;
            this.notFound = false;
            if (!this.email.trim()) {
                this.error = "Email is required.";
                return;
            }

            this.submitting = true;
            myAxios
                .post("api/Users/find-user-internal", { email: this.email.trim() })
                .then((resp) => {
                    this.applyUser(resp.data);
                })
                .catch((ex) => {
                    if (ex.response && ex.response.status === 404) {
                        this.notFound = true;
                        return;
                    }
                    this.error = this.apiError(ex, "Lookup failed.");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        createUser() {
            if (!confirm("Are you sure?")) {
                return;
            }

            this.error = null;
            this.submitting = true;
            myAxios
                .post("api/Users/register-user-internal", { email: this.email.trim() })
                .then((resp) => {
                    this.applyUser(resp.data, true);
                })
                .catch((ex) => {
                    this.error = this.apiError(ex, "Registration failed.");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
    },
};
</script>
